const prefix = 'dagligbank-lokalbank';
export const loansTrackingIDs = {
    editLoan: {
        id: `${prefix}-edit-loan`,
        name: 'edit-loan',
    },
    downpayment: {
        id: `${prefix}-downpayment-loan`,
        name: 'downpayment-loan',
    },
    interestFree: {
        id: `${prefix}-interestFree-loan`,
        name: 'interestFree-loan',
    },
    loanOverview: `${prefix}-loan-overview`,
    loanOverviewError: `${prefix}-loan-overview-error`,
    loanDetails: `${prefix}-loan-details`,
};
